export default {
    CookiesNotification: {
        errors: {
            generic: 'Ocorreu um erro ao aceitar política de cookies. Tente novamente mais tarde.',
            'agreement-already-exists': 'Você já aceitou a política de cookies.',
        }
    }
}